import { FC } from 'react'
import cn from 'classnames'

import { RewardStatus } from 'interfaces/bounty'

import styles from 'components/features/pfm/RewardDetails/RewardStatusInColor/RewardStatusInColor.styl'

type RewardsStatusInColor = {
  status: RewardStatus
  asEmptyCircle?: boolean,
  withBackgroundColor?: boolean
  className?: string
}

export const RewardsStatusInColor: FC<RewardsStatusInColor> = (props) => {
  const {
    status,
    asEmptyCircle,
    withBackgroundColor,
    className,
    children,
  } = props

  return (
    <span
      className={ cn(styles[status], {
        [styles.background]: withBackgroundColor,
        [styles.asEmptyCircle]: asEmptyCircle,
      }, className) }
    >
      { children }
    </span>
  )
}
